import {ComparatorBase, ComparisonTypeEnum} from "./ComparatorBase";
import * as React from "react";

export class StandardComparator extends ComparatorBase{



    public GetComparator(skipValueLessConditions:boolean=false){
        return (
            <select className={this.GetComparisonClass()} value={this.Condition.ConditionLineOptions.Comparison} onChange={x=>this.ComparisonChanged(x.target.value.toString())} style={{height:'auto',padding:0,width:'100%'}} >
                <option value={ComparisonTypeEnum.Equal}>Equal to</option>
                <option value={ComparisonTypeEnum.NotEqual}>Not Equal to</option>
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsEmpty}>Is Empty</option>}
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsNotEmpty}>Is Not Empty</option>}
                <option value={ComparisonTypeEnum.Contains}>Contains</option>

                <option value={ComparisonTypeEnum.GreaterThan}>Greater than</option>
                <option value={ComparisonTypeEnum.GreaterOrEqualThan}>Greater or equal than</option>
                <option value={ComparisonTypeEnum.LessThan}>Less than</option>
                <option value={ComparisonTypeEnum.LessOrEqualThan}>Less or equal than</option>
            </select>
        );
    }

    InitializeValues() {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum.Equal;
    }

    public GetValueInput(){
        let comparisonType=this.Condition.props.ConditionLineOptions.Comparison;
        return <input className={this.GetValueClass()} value={this.Condition.props.ConditionLineOptions.Value} onChange={x=>this.ValueChanged(x.target.value)} style={{minWidth:'100%',maxWidth:200,height:25,width:'100%'}} type={'text'} disabled={comparisonType==ComparisonTypeEnum.IsEmpty||comparisonType==ComparisonTypeEnum.IsNotEmpty}/>
    }



    private ComparisonChanged(s: string) {
        if(s==ComparisonTypeEnum.IsEmpty||s==ComparisonTypeEnum.IsNotEmpty)
            this.Condition.ConditionLineOptions.Value='';
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum[s];
        this.Condition.forceUpdate();
    }

    private ValueChanged(value: string) {
        this.Condition.ConditionLineOptions.Value=value;
        this.Condition.forceUpdate();
    }

}